"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSpacing;
var _unitConversion = require("../utilities/unitConversion");
function createSpacing(base) {
  function factor(value) {
    return value * base;
  }
  function transform(value) {
    if (typeof value === 'string' && isNaN(Number(value))) {
      return value;
    }
    return (0, _unitConversion.toPx)(factor(Number(value)));
  }
  function isSpacingValue(value) {
    return typeof value !== 'undefined';
  }
  return function spacing(top, right, bottom, left) {
    return [top, right, bottom, left].filter(isSpacingValue).map(transform).join(' ');
  };
}